<template>
  <div>
    <hero></hero>
    <said-about-us2></said-about-us2>
     <l-footer></l-footer>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>